import { render } from "./readExtensionMuseum.vue?vue&type=template&id=4ef223bf&scoped=true"
import script from "./readExtensionMuseum.vue?vue&type=script&lang=js"
export * from "./readExtensionMuseum.vue?vue&type=script&lang=js"

import "./readExtensionMuseum.vue?vue&type=style&index=0&id=4ef223bf&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ef223bf"]])

export default __exports__